import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e694bba6")

_pushScopeId("data-v-e694bba6")
const _hoisted_1 = { class: "pause-button-inner" }
const _hoisted_2 = {
  key: 0,
  class: "pause-button-inner-small"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_button = _resolveComponent("ion-button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_ion_button, {
      size: "small",
      class: {active: _ctx.isPaused},
      onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('open-pause-modal')))
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", null, _toDisplayString(_ctx.text), 1),
          (_ctx.isPaused)
            ? (_openBlock(), _createBlock("span", _hoisted_2, "Click to manage"))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["class"])
  ]))
})